import {ReportModel} from "@fedeltapointofsale/data-client";
import {OpenItemReportData} from "./open-item-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class OpenItemReportModel extends ReportModel<OpenItemReportData> {
    constructor(injector: Injector) {
        super(injector, OpenItemReportData);
    }

}
